import { createThemeController } from './createThemeController'

const controller = createThemeController({
  rootSelector: '.theme-mstock',
  initMode: window.__DAYFIN_INITIAL_THEME__
})

export const setMStockTheme = (mode) => {
  return controller.setMode(mode)
}

export const initMStockTheme = () => {
  window.setMStockTheme = setMStockTheme

  return controller.init()
}

export const mStockTheme = {
  init: initMStockTheme,
  setMode: setMStockTheme,
  getMode: controller.getMode
}
